// extracted by mini-css-extract-plugin
export var button = "_1f-1";
export var featuredLink = "_1f-4";
export var spinner = "_1f-2";
export var spinnerContainer = "_1f-3";
export var text = "_1f-0";